@if (modalData) {
  <div class="invite-modal-container">
    <!-- Header -->
    <div class="modal-header py-2 px-3">
      <h2>{{ modalData.heading }}</h2>
      <button
        type="button"
        class="close-btn"
        (click)="onClose()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close modal"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-content p-4">
      <div class="step-content">
        <div class="step-description">
          <p>{{ modalData.subheading }}</p>
        </div>

        <form [formGroup]="modalForm" class="form-container">
          <!-- Invite RM/Broker Admin Form -->
          @if (
            modalData.actionButton === 'Send Email Invitation' ||
            modalData.actionButton === 'Send Email Invitation Broker Admin'
          ) {
            <!-- RM ID Field (only for RM invitation) -->
            @if (modalData.actionButton === 'Send Email Invitation') {
              <div class="form-group">
                <label class="field-label">
                  {{ staticTextService.text.broker['rmIdLabel'] }}
                  <span class="required">*</span>
                </label>
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-user"></i>
                  </p-inputgroup-addon>
                  <input
                    pInputText
                    type="text"
                    placeholder="Enter RM ID"
                    formControlName="virtualRMId"
                  />
                </p-inputgroup>
                @if (
                  modalForm.get('virtualRMId')?.hasError('required') &&
                  modalForm.get('virtualRMId')?.touched
                ) {
                  <small class="error-message">
                    {{ staticTextService.text.broker['rmIdRequiredError'] }}
                  </small>
                }
              </div>
            }

            <!-- First Name -->
            <div class="form-group">
              <label class="field-label">
                @if (modalData.actionButton === 'Send Email Invitation') {
                  <span>{{
                    staticTextService.text.broker['rmFirstNameLabel']
                  }}</span>
                }
                @if (
                  modalData.actionButton ===
                  'Send Email Invitation Broker Admin'
                ) {
                  <span>{{
                    currentRoleId === 5
                      ? 'Advisor First Name'
                      : 'Broker First Name'
                  }}</span>
                }
                <span class="required">*</span>
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  placeholder="Enter First Name"
                  formControlName="firstName"
                />
              </p-inputgroup>
              @if (
                modalForm.get('firstName')?.hasError('required') &&
                modalForm.get('firstName')?.touched
              ) {
                <small class="error-message">
                  @if (modalData.actionButton === 'Send Email Invitation') {
                    <span>{{
                      staticTextService.text.broker['rmFirstNameRequiredError']
                    }}</span>
                  }
                  @if (
                    modalData.actionButton ===
                    'Send Email Invitation Broker Admin'
                  ) {
                    <span>{{
                      currentRoleId === 5
                        ? 'Advisor First Name is Required'
                        : 'Broker First Name is Required'
                    }}</span>
                  }
                </small>
              }
            </div>

            <!-- Middle Name -->
            <div class="form-group">
              <label class="field-label">
                @if (modalData.actionButton === 'Send Email Invitation') {
                  <span>{{
                    staticTextService.text.broker['rmMiddleNameLabel']
                  }}</span>
                }
                @if (
                  modalData.actionButton ===
                  'Send Email Invitation Broker Admin'
                ) {
                  <span>{{
                    currentRoleId === 5
                      ? 'Advisor Middle Name'
                      : 'Broker Middle Name'
                  }}</span>
                }
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  placeholder="Enter Middle Name"
                  formControlName="middleName"
                />
              </p-inputgroup>
            </div>

            <!-- Last Name -->
            <div class="form-group">
              <label class="field-label">
                @if (modalData.actionButton === 'Send Email Invitation') {
                  <span>{{
                    staticTextService.text.broker['rmLastNameLabel']
                  }}</span>
                }
                @if (
                  modalData.actionButton ===
                  'Send Email Invitation Broker Admin'
                ) {
                  <span>{{
                    currentRoleId === 5
                      ? 'Advisor Last Name'
                      : 'Broker Last Name'
                  }}</span>
                }
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  placeholder="Enter Last Name"
                  formControlName="lastName"
                />
              </p-inputgroup>
            </div>

            <!-- Email -->
            <div class="form-group">
              <label class="field-label">
                {{ staticTextService.text.broker['emailLabel'] }}
                <span class="required">*</span>
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-envelope"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="email"
                  placeholder="Enter Email"
                  formControlName="email"
                />
              </p-inputgroup>
              @if (
                (modalForm.get('email')?.hasError('email') ||
                  modalForm.get('email')?.hasError('pattern')) &&
                modalForm.get('email')?.touched
              ) {
                <small class="error-message">
                  {{ staticTextService.text.broker['emailPatternError'] }}
                </small>
              }
              @if (
                modalForm.get('email')?.hasError('required') &&
                modalForm.get('email')?.touched
              ) {
                <small class="error-message">
                  {{ staticTextService.text.broker['emailRequiredError'] }}
                </small>
              }
            </div>

            <!-- Phone Number -->
            <div class="form-group">
              <label class="field-label">
                {{ staticTextService.text.broker['mobileLabel'] }}
                <span class="required">*</span>
              </label>
              <p-inputgroup>
                <p-inputgroup-addon class="mobile-prefix">
                  <img
                    src="../../../../assets/images/phoneFlag.svg"
                    alt="India Flag"
                    class="flag-icon"
                  />
                  +91
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  placeholder="Enter Phone Number"
                  formControlName="phoneNo"
                  maxlength="10"
                  (input)="filterNumericInput($event)"
                  (blur)="validatePhoneNumber()"
                />
              </p-inputgroup>
              @if (
                modalForm.get('phoneNo')?.hasError('required') &&
                modalForm.get('phoneNo')?.touched &&
                !startsWithZero()
              ) {
                <small class="error-message">
                  {{ staticTextService.text.broker['mobileRequiredError'] }}
                </small>
              }
              @if (
                modalForm.get('phoneNo')?.hasError('pattern') &&
                modalForm.get('phoneNo')?.touched
              ) {
                <small class="error-message">
                  {{ staticTextService.text.broker['mobilePatternError'] }}
                </small>
              }
              @if (startsWithZero() && modalForm.get('phoneNo')?.touched) {
                <small class="error-message">
                  {{
                    staticTextService.text.broker['mobileStartsWithZeroError']
                  }}
                </small>
              }
            </div>

            <!-- EUIN Field (only for RM invitation and non-advisor roles) -->
            @if (
              modalData.actionButton === 'Send Email Invitation' &&
              currentRoleId !== 5
            ) {
              <div class="form-group">
                <label class="field-label">
                  {{ staticTextService.text.broker['euinLabel'] }}
                  <span class="required">*</span>
                </label>
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-id-card"></i>
                  </p-inputgroup-addon>
                  <input
                    pInputText
                    type="text"
                    placeholder="Enter EUIN"
                    maxlength="7"
                    formControlName="euin"
                  />
                </p-inputgroup>
                @if (
                  modalForm.get('euin')?.hasError('required') &&
                  modalForm.get('euin')?.touched
                ) {
                  <small class="error-message">
                    {{ staticTextService.text.broker['euinRequiredError'] }}
                  </small>
                }
                @if (
                  modalForm.get('euin')?.hasError('pattern') &&
                  modalForm.get('euin')?.touched
                ) {
                  <small class="error-message">
                    {{ staticTextService.text.broker['euinPatternError'] }}
                  </small>
                }
              </div>
            }
          }

          <!-- Assign/Reassign RM Form -->
          @if (
            modalData.actionButton === 'Assign RM' ||
            modalData.actionButton === 'Reassign RM or Broker' ||
            modalData.actionButton === 'Reassign RM or Advisor'
          ) {
            <!-- Client Name (Read-only) -->
            <div class="form-group">
              <label class="field-label">
                {{ staticTextService.text.broker['clientNameLabel'] }}
                <span class="required">*</span>
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  [value]="clientName"
                  readonly
                  class="readonly-field"
                />
              </p-inputgroup>
            </div>

            <!-- Existing RM Info (for reassign) -->
            @if (
              modalData.actionButton === 'Reassign RM or Broker' ||
              modalData.actionButton === 'Reassign RM or Advisor'
            ) {
              <div class="info-box">
                <p class="info-label">
                  Existing
                  {{ currentRoleId === 5 ? 'RM/Advisor' : 'RM/Broker' }}:
                  <span class="info-value">
                    {{ modalData.assignedRMFirstName ?? '' }}
                    {{ modalData.assignedRMMiddleName ?? '' }}
                    {{ modalData.assignedRMLastName ?? '' }}
                  </span>
                </p>
              </div>
            }

            <!-- New RM Selection -->
            <div class="form-group">
              <label class="field-label">
                New RM/Broker
                <span class="required">*</span>
              </label>
              <p-select
                formControlName="newMappingUserId"
                [options]="rmOptions()"
                optionLabel="label"
                optionValue="value"
                [placeholder]="
                  currentRoleId === 5
                    ? 'Search or select RM/Advisor'
                    : 'Search or select RM/Broker'
                "
                [filter]="true"
                filterPlaceholder="Search"
                [showClear]="!!modalForm.get('newMappingUserId')?.value"
                styleClass="w-100"
                panelStyleClass="full-width-dropdown-panel"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                appendTo="body"
                (onChange)="onRmSelect($event)"
              />
              @if (
                modalForm.get('newMappingUserId')?.hasError('required') &&
                modalForm.get('newMappingUserId')?.touched
              ) {
                <small class="error-message">
                  {{
                    currentRoleId === 5
                      ? 'Please select a new RM/Advisor'
                      : 'Please select a new RM/Broker'
                  }}
                </small>
              }
            </div>
          }

          <!-- Assign/Reassign Client Form -->
          @if (
            modalData.actionButton === 'Assign Client' ||
            modalData.actionButton === 'Reassign Client'
          ) {
            <!-- Selected entity (Read-only) -->
            <div class="form-group">
              <label class="field-label">
                @if (modalData.entityType === 'advisor') {
                  Selected Advisor
                } @else if (modalData.entityType === 'broker') {
                  Selected Broker
                } @else {
                  Selected RM
                }
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  [value]="rmName"
                  readonly
                  class="readonly-field"
                />
              </p-inputgroup>
            </div>

            <!-- Client Selection -->
            <div class="form-group">
              <label class="field-label">
                Client Name/PAN
                <span class="required">*</span>
              </label>
              <p-select
                formControlName="clientUserId"
                [options]="clientOptions()"
                optionLabel="label"
                optionValue="value"
                placeholder="Search or select client"
                [filter]="true"
                filterPlaceholder="Search"
                [showClear]="!!modalForm.get('clientUserId')?.value"
                styleClass="w-full"
                panelStyleClass="full-width-dropdown-panel"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                appendTo="body"
                (onChange)="onClientSelect($event)"
              />

              @if (
                modalForm.get('clientUserId')?.hasError('required') &&
                modalForm.get('clientUserId')?.touched
              ) {
                <small class="error-message"> Please select a client </small>
              }
            </div>

            <!-- Existing RM Info -->
            @if (showExistingRm()) {
              <div class="info-box">
                @if (existingRmDetails.rmUserId) {
                  <p class="info-label">
                    Existing
                    {{ currentRoleId === 5 ? 'RM/Advisor' : 'RM/Broker' }}:
                    <span class="info-value">
                      {{ existingRmDetails.rmFirstName || '' }}
                      {{ existingRmDetails.middleName || '' }}
                      {{ existingRmDetails.lastName || '' }}
                    </span>
                  </p>
                }
                @if (!existingRmDetails.rmUserId) {
                  <p class="info-label">
                    Existing
                    {{ currentRoleId === 5 ? 'RM/Advisor' : 'RM/Broker' }}:
                    <span class="info-value">
                      {{
                        staticTextService.text.broker['existingRmNotAssigned']
                      }}
                    </span>
                  </p>
                }
              </div>
            }
          }

          <!-- Update Dependants Form -->
          @if (modalData.actionButton === 'Update Dependants') {
            <!-- Client Name (Read-only) -->
            <div class="form-group">
              <label class="field-label">
                {{ staticTextService.text.broker['clientNameLabel'] }}
                <span class="required">*</span>
              </label>
              <p-inputgroup>
                <p-inputgroup-addon>
                  <i class="pi pi-user"></i>
                </p-inputgroup-addon>
                <input
                  pInputText
                  type="text"
                  [value]="clientName"
                  readonly
                  class="readonly-field"
                />
              </p-inputgroup>
            </div>

            <!-- Dependants Selection with PrimeNG MultiSelect -->
            <div class="form-group">
              <label class="field-label">Select Dependants</label>
              <p-multiSelect
                [options]="dependantOptions()"
                [(ngModel)]="selectedDependants"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="clientData($event.value)"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Client Name/PAN"
                [showToggleAll]="false"
                [filter]="true"
                filterPlaceHolder="Search clients"
                display="chip"
                styleClass="w-full"
                [virtualScroll]="true"
                [virtualScrollItemSize]="38"
                [scrollHeight]="'250px'"
                appendTo="body"
              >
                <ng-template let-client pTemplate="item">
                  <div class="client-option">
                    <span>{{ client.label }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </div>
          }

          <!-- Email to Client Checkbox -->
          @if (
            modalData.actionButton === 'Assign RM' ||
            modalData.actionButton === 'Reassign RM or Broker' ||
            modalData.actionButton === 'Reassign RM or Advisor' ||
            modalData.actionButton === 'Assign Client' ||
            modalData.actionButton === 'Reassign Client'
          ) {
            <div class="checkbox-container p-2 d-flex align-items-center">
              <p-checkbox
                formControlName="emailToClient"
                [binary]="true"
                inputId="emailToClient"
                (onChange)="onChangeChecked($event, modalData)"
              ></p-checkbox>
              <label for="emailToClient" class="checkbox-label">
                {{ staticTextService.text.broker['sendEmailToClient'] }}
              </label>
            </div>
          }
        </form>

        <!-- Footer Buttons -->
        <div class="button-container m-auto">
          <p-button
            [label]="
              modalData.actionButton === 'Send Email Invitation Broker Admin'
                ? 'Send Email Invitation'
                : modalData.actionButton
            "
            [loading]="loading()"
            [disabled]="
              modalForm.invalid ||
              (modalData.actionButton === 'Update Dependants' &&
                !dependantsChanged())
            "
            (click)="onSubmit()"
            styleClass="primary-btn w-full"
            icon="pi pi-check"
            role="button"
            tabindex="0"
            (keydown.enter)="
              $event.target === $event.currentTarget &&
                $any($event.currentTarget).click()
            "
            (keydown.space)="
              $event.target === $event.currentTarget && $event.preventDefault();
              $event.target === $event.currentTarget &&
                $any($event.currentTarget).click()
            "
          />
        </div>
      </div>
    </div>
  </div>
}
